import React, {useEffect, useState} from 'react';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {AutoComplete} from "primereact/autocomplete";

import {LanguageService} from "../../service/LanguageService";
import {emailValidator, formValid, getKeyValue} from "../../utils/Utils";
import {getTimeZoneDisplay} from "../../utils/TimeUtil";




import moment from "moment";
import "moment-timezone";

import {Dialog} from "primereact/dialog";
import {Message} from "primereact/message";
import {UserService} from "../../service/UserService";
import {Checkbox} from "primereact/checkbox";
import {TabPanel, TabView} from "primereact/tabview";
import {product_codes, usage_types} from "../../utils/Constants";
import {AppContext} from "../../HomePage";
import {Calendar} from "primereact/calendar";
import JobSchedulingSetting from "./JobSchedulingSetting";


const UpdateUser = (props) => {

    const {t, setError} = React.useContext(AppContext);

    const [user, setUser] = useState({...props.selectedUser});
    const [variantImport, setVariantImport] = useState(user.settings.variant_import !== null &&  user.settings.variant_import !== undefined ? user.settings.variant_import : false);
    const [useStorePrice, setUseStorePrice] = useState(user.settings.use_store_price !== null &&  user.settings.use_store_price !== undefined ? user.settings.use_store_price : false);
    const [allowCurrencyEntry, setAllowCurrencyEntry] = useState(user.settings.allow_currency_entry !== null &&  user.settings.allow_currency_entry !== undefined ? user.settings.allow_currency_entry : false);
    const [newSellerAutomaticallyActivated, setNewSellerAutomaticallyActivated] = useState(user.settings.new_seller_automatically_activated !== null &&  user.settings.new_seller_automatically_activated !== undefined ? user.settings.new_seller_automatically_activated : true);
    const [sellerCode, setSellerCode] = useState(user.settings.seller_code ? user.settings.seller_code : null);
    const [decimalSeparator, setDecimalSeparator] = useState(user.settings.decimal_separator ? user.settings.decimal_separator : '.');
    const [defaultProductCode, setDefaultProductCode] = useState(user.settings.default_product_code ? user.settings.default_product_code : null);
    const [violationEmail, setViolationEmail] = useState(user.settings.violation_email ? user.settings.violation_email : null);
    const [apiAccessEnabled, setApiAccessEnabled] = useState(user.settings.api_access_enabled !== null && user.settings.api_access_enabled !== undefined ? user.settings.api_access_enabled : false);
    const [manualCompetitorPricesEnabled, setManualCompetitorPricesEnabled] = useState(!!user.settings.manual_competitor_prices_enabled);
    const [categoryPriceComparisonEnabled, setCategoryPriceComparisonEnabled] = useState(user.settings.category_price_comparison_enabled !== null && user.settings.category_price_comparison_enabled !== undefined ? user.settings.category_price_comparison_enabled : false);
    const [formErrors, setFormErrors] = useState({});

    const [disabled, setDisabled] = useState(false);

    const languages = LanguageService.getLanguages();
    const timezones = moment.tz.names();
    const [timezoneSuggestions, setTimezoneSuggestions] = useState(null);


    const [activeIndex, setActiveIndex] = useState(0);
    const [allUsers, setAllUsers] = useState([]);

    const userService = new UserService();

    useEffect(() => {
        if (!user.default_campaign || !user.default_campaign.settings) {
            user.default_campaign = {settings: {scraping_jobs:[]}}
        }
        userService.getAllUsers().then(allUsers=>{
            setAllUsers(allUsers.map(user => ({label: user.email, value: user.id})));
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    }, []);

    const suggestTimezones = (event) => {
        if (timezones !== null)
        {
            let results = timezones.filter(timezone => {
                return getTimeZoneDisplay(timezone).toLowerCase().includes(event.query.toString().toLowerCase());
            });
            setTimezoneSuggestions(results);
        }
    };

    const save = () => {

        if (disabled) {
            return;
        }
        setDisabled(true);

        checkErrors(user).then(formErrors=> {
            if (formValid(formErrors)) {
                userService.updateUser(user).then(user_updated=>{
                    setDisabled(false);
                    props.userUpdateCompleted(user);
                }).catch(error =>{
                    setError(error);
                    setError(null);
                    setDisabled(false);
                });
            }
            else
                setFormErrors(formErrors);
        });
    };

    const timezoneTemplate = (e) => {
        return getTimeZoneDisplay(e);
    };

    const languageTemplate = (e) => {
        return e.label;
    };

    const onChange = (e, a) => {

        const { key, value } = getKeyValue(e);

        setFormErrors({...formErrors, [key]: checkError(key, value)});

        if (a) {
            a[key] = value;
            setUser({...user});
        }
        else
            setUser({...user, [key] : value});
    };

    const errorClass = (key) => {
        return formErrors[key] && formErrors[key].length > 0 ? "p-error" : null
    };

    const checkError = (key, value) => {
        let errorText = "";

        if (key === "first_name") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }
        else if (key === "last_name") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }
        else if (key === "email") {
            errorText =  value.length > 0 ? emailValidator(value, t) : t('validations.invalid_email');
        }
        else if (key === "language") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }
        else if (key === "timezone") {
            errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        }
        // else if (key === "country") {
        //     errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        // }
        // else if (key === "currency") {
        //     errorText =  value.length > 0 ? "" : t('validations.invalid_value');
        // }
        else if (key === "manufacturer") {
            errorText =  value === true || value === false ? "" : t('validations.invalid_value');
        }

        return errorText;
    }

    const checkErrors = async (user) => {

        let errors = { ...formErrors };

        Object.entries(user).forEach(([key, value]) => {
            errors[key] = checkError(key, value);
        });

        errors['violation_email'] = violationEmail ? emailValidator(violationEmail, t) : '';

        return errors;
    };


    const editModalButtons = (
        <div>
            <Button label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => props.hideDialog()} />
            <Button label={t('actions.save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={save} />
        </div>
    );

    return (
        <Dialog header={`${t('user.update_user')} — ${(`${user.first_name || ''} ${user.last_name || ''}`).trim() || user.email}`}  footer={editModalButtons} visible={true} className="update-user-dialog" style={{maxWidth: '80vw', minWidth: '40vw'}} modal={true} onHide={() => props.hideDialog()}>


            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel  header={t('user.settings.settings')}>
                    <div className="p-grid alignCenter p-fluid">
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="variantImport" name="variantImport"
                                      tooltip={t('user.settings.help.variant_import')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={variantImport}
                                      checked={variantImport}
                                      onChange={(e)=> {
                                          user.settings.variant_import = getKeyValue(e).value;
                                          setVariantImport(getKeyValue(e).value);}}
                            />
                            <label htmlFor="variantImport" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('campaign.variant_import')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="api_access_enabled" name="api_access_enabled"
                                      tooltip={t('user.settings.help.api_access_enabled')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={apiAccessEnabled}
                                      checked={apiAccessEnabled}
                                      onChange={(e)=> {
                                          user.settings.api_access_enabled = getKeyValue(e).value;
                                          setApiAccessEnabled(getKeyValue(e).value);}}
                            />
                            <label htmlFor="api_access_enabled" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('user.settings.api_access_enabled')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="manual_competitor_prices_enabled" name="manual_competitor_prices_enabled"
                                      tooltip={t('user.settings.help.manual_competitor_prices_enabled')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={manualCompetitorPricesEnabled}
                                      checked={manualCompetitorPricesEnabled}
                                      onChange={(e)=> {
                                          user.settings.manual_competitor_prices_enabled = getKeyValue(e).value;
                                          setManualCompetitorPricesEnabled(getKeyValue(e).value);}}
                            />
                            <label htmlFor="manual_competitor_prices_enabled" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('user.settings.manual_competitor_prices_enabled')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="category_price_comparison_enabled" name="category_price_comparison_enabled"
                                      tooltip={t('user.settings.help.category_price_comparison_enabled')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={categoryPriceComparisonEnabled}
                                      checked={categoryPriceComparisonEnabled}
                                      onChange={(e)=> {
                                          user.settings.category_price_comparison_enabled = getKeyValue(e).value;
                                          setCategoryPriceComparisonEnabled(getKeyValue(e).value);}}
                            />
                            <label htmlFor="category_price_comparison_enabled" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('user.settings.category_price_comparison_enabled')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="use_store_price" name="use_store_price"
                                      tooltip={t('user.settings.help.use_store_price')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={useStorePrice}
                                      checked={useStorePrice}
                                      onChange={(e)=> {
                                          user.settings.use_store_price = getKeyValue(e).value;
                                          setUseStorePrice(getKeyValue(e).value);}}
                            />
                            <label htmlFor="use_store_price" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('reprice.sale_value')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="new_seller_automatically_activated" name="new_seller_automatically_activated"
                                      tooltip={t('user.settings.help.new_seller_automatically_activated')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={newSellerAutomaticallyActivated}
                                      checked={newSellerAutomaticallyActivated}
                                      onChange={(e)=> {
                                          user.settings.new_seller_automatically_activated = getKeyValue(e).value;
                                          setNewSellerAutomaticallyActivated(getKeyValue(e).value);}}
                            />
                            <label htmlFor="new_seller_automatically_activated" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('campaign.new_seller_automatically_activated')}</label>
                        </div>
                        <div className="p-col-12 settings-check">
                            <Checkbox inputId="allow_currency_entry" name="allow_currency_entry"
                                      tooltip={t('user.settings.help.allow_currency_entry')} tooltipOptions={{position: 'top'}}
                                      style={{marginLeft: "0.5em"}}
                                      value={allowCurrencyEntry}
                                      checked={allowCurrencyEntry}
                                      onChange={(e)=> {
                                          user.settings.allow_currency_entry = getKeyValue(e).value;
                                          setAllowCurrencyEntry(getKeyValue(e).value);}}
                            />
                            <label htmlFor="allow_currency_entry" style={{marginLeft:"0.5em", marginRight:"0.5em"}}>{t('user.settings.allow_currency_entry')}</label>
                        </div>
                        <div className="p-col-12 settings-divider"></div>
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="seller_code" name="seller_code" tooltip={t('user.settings.help.seller_code')} tooltipOptions={{position: 'top'}} value={sellerCode} onChange={(e)=>{user.settings.seller_code = e.target.value; setSellerCode(e.target.value);}}/>
                                <label htmlFor="seller_code">{t('campaign.seller_code')}</label>
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="violation_email" name="violation_email" tooltip={t('user.settings.help.violation_email')} tooltipOptions={{position: 'top'}} value={violationEmail} className={errorClass("violation_email")} onChange={(e)=>{user.settings.violation_email = e.target.value; setViolationEmail(e.target.value);}}/>
                                <label htmlFor="violation_email">{t('user.violation_email')}</label>
                                {errorClass("violation_email") && (<Message severity="error" text={formErrors.violation_email}/>)}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <InputText id="decimal_separator" name="decimal_separator" tooltip={t('user.settings.help.decimal_separator')} tooltipOptions={{position: 'top'}} value={decimalSeparator} onChange={(e)=>{user.settings.decimal_separator = e.target.value; setDecimalSeparator(e.target.value);}}/>
                                <label htmlFor="decimal_separator">{t('campaign.decimal_separator')}</label>
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="p-float-label">
                                <Dropdown name="default_product_code" tooltip={t('user.settings.help.default_product_code')} tooltipOptions={{position: 'top'}} value={defaultProductCode} options={product_codes(t)} onChange={(e)=>{user.settings.default_product_code = getKeyValue(e).value; setDefaultProductCode(getKeyValue(e).value);}}/>
                                <label htmlFor="default_product_code">{t('user.default_product_code')}</label>
                            </span>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={t('user.user')}>
                    <div className="p-grid alignCenter p-fluid">
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="first_name" name="first_name" value={user.first_name} onChange={onChange} className={errorClass("first_name")}/>
                                {errorClass("first_name") && (<Message severity="error" text={formErrors.first_name}/>)}
                                <label htmlFor="first_name">{t('user.first_name')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="last_name" name="last_name" value={user.last_name} onChange={onChange} className={errorClass("last_name")}/>
                                {errorClass("last_name") && (<Message severity="error" text={formErrors.last_name}/>)}
                                <label htmlFor="last_name">{t('user.last_name')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="email" name="email" value={user.email} autoComplete="off" onChange={onChange} className={errorClass("email")}/>
                                {errorClass("email") && (<Message severity="error" text={formErrors.email}/>)}
                                <label htmlFor="email">{t('user.email')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <Dropdown id="usage_type" name="usage_type" value={user.usage_type} options={usage_types(t)} onChange={onChange} />
                                <label htmlFor="usage_type">{t('campaign.usage_type')}</label>
                            </span>
                        </div>



                        <div className="p-col-6">
                            <span className="p-float-label">
                                <Dropdown id="language" name="language" value={user.language} options={languages} onChange={onChange} itemTemplate={languageTemplate} style={{width:'100%'}} className={errorClass("language")}/>
                                <label htmlFor="language">{t('user.language')}</label>
                                {errorClass("language") && (<Message severity="error" text={formErrors.language}/>)}
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <AutoComplete id="timezone" name="timezone" field="label" dropdown={true} value={user.timezone} suggestions={timezoneSuggestions} onChange={onChange} completeMethod={suggestTimezones.bind(this)} itemTemplate={timezoneTemplate} className={errorClass("timezone")}/>
                                {errorClass("timezone") && (<Message severity="error" text={formErrors.timezone}/>)}
                                <label htmlFor="timezone">{t('user.timezone')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="country" name="country" value={user.country} autoComplete="off" onChange={onChange} className={errorClass("country")}/>
                                {errorClass("country") && (<Message severity="error" text={formErrors.country}/>)}
                                <label htmlFor="country">{t('user.country')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="currency" name="currency" value={user.currency} autoComplete="off" onChange={onChange} className={errorClass("currency")}/>
                                {errorClass("currency") && (<Message severity="error" text={formErrors.currency}/>)}
                                <label htmlFor="currency">{t('product.currency')}</label>
                            </span>
                        </div>

                        <div className="p-col-12">
                            <Message severity="info" text={"Payment"}/>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="payment_cycle" name="payment_cycle" value={user.payment_cycle} autoComplete="off" onChange={onChange}/>
                                <label htmlFor="payment_cycle">{t('user.payment_cycle')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <Calendar id="next_payment_date" name="next_payment_date" value={user.next_payment_date ? new Date(user.next_payment_date) : null} onChange={onChange} showIcon={true} dateFormat="yy-mm-dd" showButtonBar={true}/>
                                <label htmlFor="next_payment_date">{t('user.next_payment_date')}</label>
                            </span>
                        </div>
                        <div className="p-col-12">
                            <span className="p-float-label">
                                <InputText id="balance" name="balance" value={user.balance} autoComplete="off" onChange={onChange} className={errorClass("balance")}/>
                                {errorClass("balance") && (<Message severity="error" text={formErrors.balance}/>)}
                                <label htmlFor="balance">{t('user.balance')}</label>
                            </span>
                        </div>
                        <div className="p-col-12">
                            <Message severity="info" text={"Referrer"}/>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <Dropdown id="referred_by" name="referred_by" filter showClear value={user.referred_by} options={allUsers} onChange={onChange} />
                                <label htmlFor="referred_by">{t('user.referred_by')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <InputText id="referring_rate" name="referring_rate" value={user.referring_rate} autoComplete="off" onChange={onChange}/>
                                <label htmlFor="referring_rate">{t('user.referring_rate')}</label>
                            </span>
                        </div>
                        <div className="p-col-12">
                            <Message severity="info" text={"Management"}/>
                        </div>
                        <div className="p-col-6">
                            <span className="p-float-label">
                                <Dropdown id="managed_by" name="managed_by" filter showClear value={user.managed_by} options={allUsers} onChange={onChange} />
                                <label htmlFor="managed_by">{t('user.managed_by')}</label>
                            </span>
                        </div>
                        <div className="p-col-6">
                            <Checkbox inputId="is_manager" name="is_manager"
                                      className="p-mt-3"
                                      value={user.is_manager}
                                      checked={user.is_manager}
                                      onChange={onChange}
                            />
                            <label htmlFor="is_manager" className="p-ml-1 p-mr-1">{t('user.is_manager')}</label>
                        </div>

                    </div>
                </TabPanel>
                <TabPanel header={t('user.campaign_settings')} >
                    <div className="p-grid alignCenter p-fluid" style={{minWidth: "55vw"}}>
                        <div className="p-col-12">
                            <JobSchedulingSetting campaign={user.default_campaign} user={user}/>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </Dialog>
    );
};
export default UpdateUser
